import React from 'react';
import PropTypes from 'prop-types';
import config from '@config';

const apiBase = () => String(config.apiURL || '').replace(/\/$/, '');

/** Banderas servidas por la API (public/flags/{code}.png). Sincronizar con npm run sync:flags en prode-api. */
const localFlagUrl = (code) => {
  const c = String(code).toLowerCase();
  return `${apiBase()}/flags/${c}.png`;
};

const style = {
  width: '25px',
  height: '16px',
  boxShadow: '0px 1px 1px rgba(0,0,0,0.3)',
};

const Flag = ({ code }) => {
  if (!code) {
    return null;
  }
  return (
    <img
      src={localFlagUrl(code)}
      alt={code}
      style={style}
      decoding="async"
      loading="lazy"
    />
  );
};

Flag.displayName = 'Flag';
Flag.propTypes = {
  code: PropTypes.string.isRequired,
};

export default Flag;
